module.exports = __webpack_public_path__ + "assets/img/rank3.50fc3104.png";